import { StepEnum } from './features/issuing-process/enums/steps.enum';

export function StringToBoolean(value: string){
  return value === "true";
}

export function setNumberWithoutSymbol(value: string): string {
  let result = '';
  for (let i = 0; i < value.length; i++) {
      if (/^\d+$/.test(value[i])) {
          result += value[i];
      }
  }
  const arr = [];
  while (result.length > 3) {
      arr.push(cut(result));
      result = result.slice(0, result.length - 3);
  }
  arr.push(cut(result));
  let finel = '';
  for (let i = arr.length - 1; i >= 0; i--) {
      finel += arr[i];
  }
  return finel;
}

export function navigateToContactUsPage() {
 window.location.href = 'https://www.max.co.il/contactus';
}

export function navigateToHomePage() {
  window.location.href = 'https://www.max.co.il';
}


function cut(str: string): string {
  return str.slice(str.length - 3 < 0 ? 0 : str.length - 3, str.length);
}

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(ua)
}


export function formatIsoDateDdMmYyyy(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return '';
  const [, y, mm, dd] = m;
  return `${dd}${mm}${y}`;
}

// Safe parse masked numeric date (ddMMyyyy) to ISO date string YYYY-MM-DDT00:00:00
export function maskedNumericToIso(raw: string | null | undefined): string {
  if (!raw || raw.length !== 8) return '';
  const dd = raw.substring(0,2);
  const mm = raw.substring(2,4);
  const yyyy = raw.substring(4,8);
  if (!/^[0-9]{8}$/.test(raw)) return '';
  return `${yyyy}-${mm}-${dd}T00:00:00`;
}


export function mapApiResponseToSteps(apiData: any, steps: any, isFullreset: boolean = false): any {
  return steps.map((step: any) => {
    const apiKey = step.stepEnum != null ? (StepEnum[step.stepEnum] as string) : undefined;
    const apiProp = apiKey ? apiKey.charAt(0).toLowerCase() + apiKey.slice(1) : undefined;
    const mapped: any = {
      ...step,
      step: apiProp ? apiData[apiProp] ?? step.step : step.step,
    };
    if (isFullreset) {
      mapped.errorFields = [];
      mapped.rc = null;
    }
    return mapped;
  });
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}
